const shadows = {
  "shadow-xs": "0px 0px 0px 1px rgba(0, 0, 0, 0.05)",
  "shadow-sm": "0px 1px 2px 0px rgba(0, 0, 0, 0.05)",
  "shadow-base": "0px 1px 2px 0px rgba(0, 0, 0, 0.06), 0px 1px 3px 0px rgba(0, 0, 0, 0.10)",
  "shadow-md": "0px 2px 4px -1px rgba(0, 0, 0, 0.06), 0px 4px 6px -1px rgba(0, 0, 0, 0.10)",
  "shadow-lg": "0px 4px 6px -2px rgba(0, 0, 0, 0.05), 0px 10px 15px -3px rgba(0, 0, 0, 0.10)",
  "shadow-xl": "0px 10px 10px -5px rgba(0, 0, 0, 0.04), 0px 20px 25px -5px rgba(0, 0, 0, 0.10)",
  "shadow-2xl": "0px 25px 50px -12px rgba(0, 0, 0, 0.25)"
};

export { shadows };
